(function () {
  'use strict';

  angular.module('app').service('PackageContentModalService', PackageContentModalService);

  PackageContentModalService.$inject = ['ModalService'];

  function PackageContentModalService(ModalService) {
    var service = {
      openPackageContentsModal: openPackageContentsModal,
      openPackageContentTranslationsModal: openPackageContentTranslationsModal,
    };

    return service;

    ////////////////

    // --------------------------- openPackageContentsModal -------------------------

    function openPackageContentsModal(pack) {
      ModalService.showModal({
        templateUrl: '/app/ajs/package-contents/modals/package-contents-modal.html',
        controller: PackageContentsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          pack: pack,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      PackageContentsModalCtrl.$inject = [
        '$element',
        'UtilService',
        'AbilityService',
        '$location',
        'PackageService',
        'PackageContentService',
        'SessionService',
        'pack',
      ];
    }

    function PackageContentsModalCtrl(
      $element,
      UtilService,
      AbilityService,
      $location,
      PackageService,
      PackageContentService,
      SessionService,
      pack
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canShow: AbilityService.can('show_package_accountadmin'),
        canCreate: AbilityService.can('create_package_accountadmin'),
        canUpdate: AbilityService.can('update_package_accountadmin'),
        canDestroy: AbilityService.can('destroy_package_accountadmin'),
      };

      vm.package = pack;
      vm.modalTitle = pack.name;

      // Methods
      vm.showContent = showContent;
      vm.deleteContent = deleteContent;
      vm.changeContentStatus = changeContentStatus;
      vm.changeContentPublished = changeContentPublished;
      vm.addContent = addContent;

      var companyWebsites = SessionService.getSelectedAccountCompany().websites;

      // Initializers
      setPackageContents();
      setAvailableWebsites();

      function setPackageContents() {
        vm.usedCompanyWebsites = [];

        var packageContents = [];

        if (vm.package.package_contents) {
          vm.package.package_contents.forEach(function (content) {
            for (var i = 0; i < companyWebsites.length; i++) {
              var companyWebsite = companyWebsites[i];
              if (content && companyWebsite.id === content.website_id) {
                content.website_name = companyWebsite.name;
                vm.usedCompanyWebsites.push(companyWebsite);
                break;
              }
            }

            packageContents.push(content);
          });
        }

        vm.package.contents = packageContents;
      }

      function setAvailableWebsites() {
        vm.availableCompanyWebsites = [];

        for (var i = 0; i < companyWebsites.length; i++) {
          var companyWebsite = companyWebsites[i];
          var found = false;
          for (var j = 0; j < vm.usedCompanyWebsites.length; j++) {
            var usedCompanyWebsite = vm.usedCompanyWebsites[j];
            if (companyWebsite.id === usedCompanyWebsite.id) {
              found = true;
              break;
            }
          }

          if (!found) {
            vm.availableCompanyWebsites.push(companyWebsite);
          }
        }
      }

      function getPackage() {
        PackageService.getPackage(vm.package.id).then(function (data) {
          vm.package = data;
          setPackageContents();
          setAvailableWebsites();
        });
      }

      function showContent(content) {
        if (!vm.permissions.canShow) {
          return;
        }

        setTimeout(function () {
          // Delay x sec
          $location.path(`/package_contents/${content.id}`).search({ WSID: content.website_id });
        }, 100);

        $element.modal('hide'); // bootstrap fade
      }

      function deleteContent(content) {
        PackageContentService.deletePackageContent(content, getPackage);
      }

      function changeContentStatus(content) {
        PackageContentService.changePackageContentStatus(content);
      }

      function changeContentPublished(content) {
        PackageContentService.changePackageContentPublished(content);
      }

      function addContent() {
        if (!vm.permissions.canCreate) {
          return;
        }

        setTimeout(function () {
          // Delay x sec
          $location
            .path(`/package_contents/new`)
            .search({ WSID: vm.website.id, packageId: vm.package.id });
        }, 100);

        $element.modal('hide'); // bootstrap fade
      }
    }

    // --------------------------- openPackageContentTranslationsModal -------------------------

    function openPackageContentTranslationsModal(itemId, websiteName, additionalLanguages) {
      ModalService.showModal({
        templateUrl: './app/ajs/package-contents/modals/package-content-detail-translation.html',
        controller: PackageContentTranslationsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          itemId: itemId,
          websiteName: websiteName,
          additionalLanguages: additionalLanguages,
        },
      }).then(function (modal) {
        var preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      PackageContentTranslationsModalCtrl.$inject = [
        'UtilService',
        'PackageContentService',
        'TagService',
        'itemId',
        'websiteName',
        'additionalLanguages',
      ];
    }

    function PackageContentTranslationsModalCtrl(
      UtilService,
      PackageContentService,
      TagService,
      itemId,
      websiteName,
      additionalLanguages
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.additionalLanguages = additionalLanguages;

      // Methods
      vm.getContent = getContent;
      vm.updateItem = updateItem;

      vm.tagTransform = tagTransform;
      vm.checkTagOptions = checkTagOptions;

      // Initializers
      getContent(additionalLanguages[0].lang);

      function getContent(language) {
        PackageContentService.getPackageContent(itemId, language).then(function (data) {
          vm.item = data;

          vm.modalTitle = vm.item.name + ' (' + websiteName + ')';

          vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(vm.item.url_video);

          vm.languageSelected = language;

          getTags(language);
        });
      }

      function updateItem(isFormValid, language) {
        vm.formErrors = false;

        var to = 'translation_form';

        if (!isFormValid) {
          vm.serverErrors = [];

          vm.formErrors = true;
          vm.UtilService.scrollToTop(to);

          return;
        }

        vm.sendingForm = true;

        // console.log(vm.item, language); return;

        PackageContentService.savePackageContent(vm.item, language).then(function (response) {
          if (response.errors) {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);

            vm.formErrors = true;
            vm.UtilService.scrollToTop(to);
          }

          vm.sendingForm = false;
        });
      }

      // ----- TAGS ----- //

      function getTags(lang) {
        TagService.getTags({ skip_check_role: true, by_lang: lang }).then(function (data) {
          vm.tags = data.items;
        });
      }

      function tagTransform(name) {
        return TagService.tagTransform(name, vm.languageSelected);
      }

      function checkTagOptions(tag) {
        vm.tagOptions = TagService.checkTagOptions(tag, vm.tags);
      }
    }
  }
})();
